import { useZodForm } from '../../../hooks/useZodForm.ts';
import { schReconciliationForm } from '../schemas.ts';

export const useReconciliationForm = () =>
  useZodForm({
    schema: schReconciliationForm,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    defaultValues: {},
  });
